import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  selectedDocumentType: {},
};

const slice = createSlice({
  name: 'DocumentTypes',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // SELECT Global Document Type
    selectGlobalDocumentType(state, action) {
      state.selectedDocumentType = action.payload;
    },

    // GET Document Types Success
    getDocumentTypesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateDocumentTypes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function selectGlobalDocumentType(selectedDocumentType) {
  dispatch(slice.actions.selectGlobalDocumentType(selectedDocumentType));
}

export function searchDocumentTypes(value) {
  return async () => {
    try {
      const response = await get(`documentType/name/${value}`);
      if (response.status) {
        dispatch(slice.actions.getDocumentTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDocumentTypes() {
  return async () => {
    try {
      const response = await get(`documentType`);
      if (response.status) {
        dispatch(slice.actions.getDocumentTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addDocumentType(body) {
  return async () => {
    try {
      const response = await post(`documentType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateDocumentTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateDocumentType(body) {
  return async () => {
    try {
      const response = await put(`documentType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateDocumentTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
